import React, { Fragment, useEffect, useState } from 'react'
import common from "../../../methods/common.js"
import QuoteHeader from '../../common/QuoteHeader'
import EdgeImage from './EdgeImage';
// import gun1 from "../../../assets/img/vacspl/gun3.jpeg"
import gun2 from "../../../assets/img/vacspl/gun4.jpeg"
import manualGun from "../../../assets/img/vacspl/manualGun.png"
import footer_image_4 from "../../../assets/img/vacspl/footer_image_4.png"
import footer_image_3 from "../../../assets/img/vacspl/footer_image_3.png"
import footer_image_2 from "../../../assets/img/vacspl/footer_image_2.png"
import footer_image_6 from "../../../assets/img/vacspl/footer_image_6.png"
import gema_logo from "../../../assets/img/vacspl/gema_logo.png"
import gema_mobile_app from "../../../assets/img/vacspl/gema_mobile_app.jpeg"
import gema_controller from "../../../assets/img/vacspl/gema_controller.png"
import injector from "../../../assets/img/vacspl/injector.webp"
import gun from "../../../assets/img/vacspl/gun.png"
// import footer_image_5 from "../../../assets/img/vacspl/footer_image_5.jpeg"
// import footer_image_1 from "../../../assets/img/vacspl/footer_image_1.png"
// import vacspl_logo from "../../../assets/img/vacspl/vacspl_logo.png"
// import plant from "../../../assets/img/vacspl/plant.jpeg"

import tablesData from "../../../assets/data/tables.json"
// import leadFormFields from "../../../assets/data/leadForm.json"
import LeadForm from './LeadForm';
import CONSTANTS from '../../../CONSTANTS.js';
import API from '../../../methods/API.js';
// import detect from '../../../methods/detect.js';
// import html2canvas from "html2canvas";

const GunQuotation = () => {
    const [data, setData] = useState({});
    const [showPdf, setShowPdf] = useState(false);
    const [loader, setLoader] = useState(false);


    useEffect(()=>{
        // let user  = window.localStorage.getItem("user");
        let date = new Date();
        let day =date.getDate()>9?date.getDate():`0${date.getDate()}`
        let month =(date.getMonth()+1)>9?(date.getMonth()+1):`0${date.getMonth()+1}`
        date = `${date.getFullYear()}-${month}-${day}`
        setData(prev=>({...prev,quotation_date:date }))

        API.getSingleQuotations("last").then((res)=>{
          console.log(res);
          if(res[0].quotations && res[0].quotations.quotation_id){
             setData(prev=>({...prev,quotation_id:res[0].quotations.quotation_id+1}))
          } else{
            setData(prev=>({...prev,quotation_id:100}))
          }
        }).catch((err)=>{
            console.log(err)
        })

    }, [])

    const updatedata = (obj) => {
        setData(prev => ({ ...prev, ...obj }))
    }

    const generatePdf=()=>{
        setShowPdf(true);
        setLoader(true)
        createScreenshotPDF()
    }
    const saveQuotationData=()=>{
        let obj = common.getGunQuotationKeyval(data);
        API.createQuotationAPI(data).then((res)=>{
            API.addClient(data).then((resp)=>{
                console.log(resp)
            }).catch((err)=>{
                console.log("Error When Saving Client")
                console.log(err)
            })
        }).catch((err)=>{
            console.log("Error When Saving Quotation")
            console.log(err)
        })
        common.saveDataOnSheet(obj, CONSTANTS.GUN_QUOTATION_SHEET_MACRO_URL)
    }

    // const testPDF = () => {
    //     // var quotes = document.getElementById('container-fluid');
    //     let quotes = document.querySelector('#quotationMain');
    //     html2canvas(quotes).then((canvas) => {
    //         //! MAKE YOUR PDF
    //         var pdf = new jsPDF('p', 'pt', 'letter');

    //         for (var i = 0; i <= quotes.clientHeight / 980; i++) {
    //             //! This is all just html2canvas stuff
    //             var srcImg = canvas;
    //             var sX = 0;
    //             var sY = 980 * i; // start 980 pixels down for every new page
    //             var sWidth = 900;
    //             var sHeight = 980;
    //             var dX = 0;
    //             var dY = 0;
    //             var dWidth = 900;
    //             var dHeight = 980;

    //             window.onePageCanvas = document.createElement("canvas");
    //             onePageCanvas.setAttribute('width', 900);
    //             onePageCanvas.setAttribute('height', 980);
    //             var ctx = onePageCanvas.getContext('2d');
    //             // details on this usage of this function: 
    //             // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
    //             ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);

    //             // document.body.appendChild(canvas);
    //             var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

    //             var width = onePageCanvas.width;
    //             var height = onePageCanvas.clientHeight;

    //             //! If we're on anything other than the first page,
    //             // add another page
    //             if (i > 0) {
    //                 pdf.addPage(612, 791); //8.5" x 11" in pts (in*72)
    //             }
    //             //! now we declare that we're working on that page
    //             pdf.setPage(i + 1);
    //             //! now we add content to that page!
    //             pdf.addImage(canvasDataURL, 'PNG', 20, 40, (width * .62), (height * .62));

    //         }
    //         //! after the for loop is finished running, we save the pdf.
    //         pdf.save('Test.pdf');
    //     });

    // }

    const createScreenshotPDF = () => {
        // setLoader(true)
        // testPDF()
        // return

        const { jsPDF } = window.jspdf;

        let doc = new jsPDF('p', 'px', [842, 595]);
        // if(detect.isMobile()){
        //     doc = new jsPDF('p','mm',[297, 210]);
        // }
        doc.putOnlyUsedFonts = true
        let pdfjs = document.querySelector('#quotationMain');

        doc.html(pdfjs, {
            autoPaging: 'text',
            callback: function (doc) {
                // setLoader(false);
                doc.save("Gema_Manual Gun_by_VACSPL.pdf");
                setLoader(false);
                saveQuotationData()
            },
            x: 0,
            y: 0
        });

    }
    const submit=()=>{
        setShowPdf(true);
    }
    if(loader){
       return  (<div className='loadinggunQuote'>
            Loading...
        </div>)
    }

    return (
        <div>
            {!showPdf ?<LeadForm updatedata={updatedata} data={data} submit={submit} />:null}
            {showPdf ?<div className='edit-details' onClick={()=>setShowPdf(false)}>Edit Details</div>:null}
            {showPdf ?<div className='download-quotation'><button onClick={generatePdf}>Download Quotation</button></div>:null}
            {showPdf ?<div className='quotation-main' id="quotationMain">
                {/* Quotation Home
                // <div className='pdfPage page1' id="page1">
                //     <QuotationHome />
                // </div> */}

                {/* First page | Index | Main Image */}
                <div className='pdfPage page1' id="page1">
                    <QuoteHeader />
                    <Content1 data={data}/>
                    <EdgeImage img={footer_image_3} extraClass={""} extraTileBG="bg-black" />
                </div>
                {/* COSTING */}
                <div className='pdfPage page1' id="page1">
                    <QuoteHeader />
                    <Costing leadData={data}/>
                    <EdgeImage img={footer_image_6} extraClass={""} extraTileBG="bg-black" />
                </div>
                {/* Images of Manual Gun */}
                <div className='pdfPage page1' id="page1">
                    <QuoteHeader />
                    <Images />
                    <EdgeImage img={footer_image_2} extraClass={""} extraTileBG="bg-black" />
                </div>
                {/* TECHNICAL DATA */}
                <div className='pdfPage page1' id="page1">
                    <QuoteHeader />
                    <TechnicalData />
                    <EdgeImage img={gun2} extraClass={""} extraTileBG="bg-black" />
                </div>
                {/* TERMS & CONDITIONS: */}
                <div className='pdfPage page1' id="page1">
                    <QuoteHeader />
                    <Conditions />
                    <EdgeImage img={footer_image_4} extraClass={""} extraTileBG="bg-black" />
                </div>
                {/* TERMS & CONDITIONS: */}
                <div className='pdfPage page1' id="page1">
                    <QuoteHeader />
                    <Content5 />
                    <EdgeImage img={gun2} extraClass={""} extraTileBG="bg-black" />
                </div>
            </div>:null}
            
        </div>
    )
}

export default GunQuotation

// const QuotationHome = () => {
//     return (
//         <div className='imahe-home-wrapper'>
//             <img className='bacImage' src={plant} alt='plant' />
//             <div className='xont'>
//                 <div className='vacspl_logo'><img src={vacspl_logo} alt='vacspl_logo' /></div>
//                 <div className='gema_logo'><img src={gema_logo} alt='gema_logo' /></div>
//                 {/* <div className='proposal-text'>
//                     A PROPOSAL BY<br/>
//                     VALUE ADDED COATING SOLUTION PVT LTD
//                     <br />------<br/>
//                     PROVIDING THE EQUIPMENT THAT WILL<br/>
//                     GIVE YOU THE "QUALITY COATING" THAT YOUR CLIENT WILL LOVE<br/>
//                 </div> */}
//                 <div>
//                     <div className='saparator'></div>
//                     <div className='prop-titlr'>Proposal for manual powder coating gun</div>
//                     <div className='saparator'></div>
//                 </div>
//                 <div className='from'> FROM <br /> Value Added Coating Solution Pvt Ltd</div>
//                 <div> To <br /> Value Added Coating Solution Pvt Ltd</div>
//             </div>
//         </div>
//     )
// }


const Content1 = (props) => {
    let {data} = props;
    let {
        contact_person_name,
        company_name,
        company_address,
        company_email,
        contact_person_designation,
        contact_person_email,
        contact_person_mobile,
        company_mobile,
        quotation_date,
        quotation_id
    } = data
    return (
        <div className='content-page-1'>
            <div className='dat-head-top'>
                <div className='num-date'>
                    <div className='num'>Ref: VACSPL/SP/2023-24/{quotation_id}</div>
                    <div className='date'>Date: {quotation_date}</div>
                </div>
                <div className='gema-logo'><img src={gema_logo} alt='gema logo' /></div>
            </div>
            <div>

            </div>
            <div className='data'>
                <div>
                    {Object.keys(data)&& Object.keys(data).length ?<Fragment>
                    <div>To</div>
                    <div className='sec-gap'>
                        {contact_person_name ? <div className='company'>{contact_person_name}</div>:null}
                        {contact_person_designation?<div>{contact_person_designation}</div>:null}
                        {contact_person_email?<div>Email: {contact_person_email}</div>:null}
                        {contact_person_mobile?<div>Mobile: +91-{contact_person_mobile}</div>:null}
                    </div>
                    <div className='sec-gap'>
                        {company_name ?<div className=''>Company Name: <strong>{company_name}</strong></div>:null}
                        {company_address?<div className='address'>{company_address}</div>:null}
                        {company_email?<div>Email: {company_email}</div>:null}
                        {company_mobile?<div>Mobile: +91-{company_mobile}</div>:null}
                    </div>
                    </Fragment>:null}
                    <div className='subject'>Subject: <strong>Quotation for Manual Powder Coating Gun</strong></div>
                    <p>Dear Sir, <br />This has reference to our discussion regarding the Powder Coating Manual Gun.</p>
                    <h4>THIS PROPOSAL INCLUDES</h4>
                    <ul>
                        <li>Machine Images for Reference</li>
                        <li> Technical Data
                            <li className='subpoint'>Electrical Data </li>
                            <li className='subpoint'>Pneumatical Data</li>
                            <li className='subpoint'>Application Data</li>
                        </li>
                        <li>Operating conditions</li>
                        <li>Details of Machine Unit ( Parts) Costing</li>
                        <li>Terms & Consitions</li>
                    </ul>
                </div>
                <div>
                    <img src={manualGun} alt='' className='gunmachine' />
                </div>
            </div>
        </div>
    )
}



const TechnicalData = () => {
    const data = tablesData.technicaldata;
    let tables = data.data;
    console.log(data)
    return (
        <div className='content-page-1 pad-mar-10'>
            <div className='tablemainName'>{data.tableName}</div>
            <DataSpecTable data={tables.electricalData} />
            <DataSpecTable data={tables.pneumaticalData} />
            <DataSpecTable data={tables.applicationData} />
            <DataSpecTable data={tables.operatingData} />
        </div>
    )
}

const DataSpecTable = (props) => {
    let { data } = props;
    // let title = data.tableName;
    let table = data.data
    return (
        <div className='spectable'>

            <table>
                <thead>
                    <tr>
                        {data.head.map(item => <th>{item.key}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {table.map((item, i) => (
                        <tr className={item.bold ? "bold" : ""}>
                            <td>{item.sn ? item.sn : i + 1}</td>
                            <td>{item.key}</td>
                            <td>{item.value}</td>
                            {item.value2 ? <td>{item.value2}</td> : null}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

const Costing = (props) => {
    let {leadData} = props
    const data = tablesData.technicaldata;
    let tables = data.data;
    let costing = tables.costingData;
    if(leadData && leadData.price){
        let val = Number(leadData.price).toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            style: 'currency',
            currency: 'INR'
        }) + " /-";

        costing.data[0].value2 = "INR " + val.slice(1, val.length)
    }
    if(leadData.quantity){
        costing.data[0].value = leadData.quantity + " No.";
    }
    let total = Number(leadData.price * leadData.quantity).toLocaleString('en-IN', {
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'INR'
    }) ;
    total = "INR " + total.slice(1, total.length)
    return (
        <div className='content-page-1 pad-mar-10'>
            <div className='tablemainName'>PRICE SUMMARY</div>
            <div className='highlightText'> STAND ALONE UNIT of GEMA Manual Powder Coating Gun (OptiFlex - Pro)</div>
            <DataSpecTable data={tables.descriptionData} />
            <DataSpecTable data={tables.costingData} />
            <div className='highlightText txt-ac'>
                <div>
                    <strong>TOTAL - {total} /-</strong>
                </div>
                <div>
                    ( {common.capitalizeFirstLetter(common.number2text(leadData.price * leadData.quantity))} )
                </div>
                <div>+ GST</div>
            </div>

        </div>
    )
}

const Conditions = () => {
    let conditions = tablesData.conditions;

    return (
        <div className='content-page-1 pad-l20 conditionPage'>
            <div className='heading'>TERMS & CONDITIONS:</div>
            <div className='pad-mar-10 f-12'>{conditions.coreCondition.map(item => (
                <div className='df-cond'> <strong>{item.key}: </strong>{item.value}
                    {/* <div className='condType'>{item.key}</div>
                <div className='"condit'>{item.value}</div> */}
                </div>
            ))}


            </div>
            <ListWithHeading data={conditions.spareCondition} />
            <ListWithHeading data={conditions.exclusionsCondition} />
            {/* <ListWithHeading data={conditions.providedByClient} /> */}
        </div>
    )
}

const ListWithHeading = (props) => {
    return (
        <div>
            <div className='listWithHEading-title'>{props.data.title}</div>
            <div className='f-12'>
                <ul>
                    {props.data.data.map(item => <li>{item}</li>)}
                </ul>
            </div>
        </div>
    )
}

const Content5 = () => {
    let conditions = tablesData.conditions;
    return (
        <div className='content-page-1 pad-mar-10 LastPage'>
            <ListWithHeading data={conditions.providedByClient} />
            <div className='lastDiv'>
                <div>We are sure that you will find our commercial offer in line with your acceptation and will place your valuable order with us.</div>
                <div className='sign'>
                    <div><strong>Value Added Coating Solution Pvt. Ltd.</strong></div>
                    <div>Harish Sharma</div>
                    <div>Director</div>
                    <div>+91-9811846214</div>
                </div>

            </div>

        </div >
    )
}

const Images = () => {
    return (
        <div>
            <div className='tablemainName pl20'>IMAGES</div>
            <div className='image-page'>
                <div className='image-app'>
                    <img src={gema_mobile_app} alt='' />
                    <div className='img-title'>Gema Mobile App</div>
                    <div className='img-dis'>(To Monitor the whole system)</div>
                </div>
                <div className='image-app'>
                    <img src={gema_controller} alt='' />
                    <div className='img-title'> OptiStar® 4.0-Gun Controls</div>
                    <div className='img-dis'>(It controls all activities)</div>
                </div>
                <div className='image-app'>
                    <img src={gun} alt='' />
                    <div className='img-title'> PowerBoost®</div>
                    <div className='img-dis'>(Safe Technology For More Power performance)</div>
                </div>
                <div className='image-app'>
                    <img src={injector} alt='' />
                    <div className='img-title'> OptiFlow Injector </div>
                    <div className='img-dis'>(For Repeatable Quality)</div>
                </div>

            </div>
        </div>
    )
}

